import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Row, Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useQuery, useMutation } from "graphql-hooks";

import ContentSection from '@components/common/ContentSection/ContentSection';
import ManageProducts from '@components/product/ManageProducts';
import Loader from '@components/common/Loader/Loader';
import Unavailable from '@components/common/Unavailable/Unavailable';

import { sendSuccessNotification, sendErrorNotification } from '@actions/notificationActions';

const GET_PRODUCTS = `
  query GetProducts($id: ID!) {
    group(id: $id) {
      region
      taskProducts {
        product {
          id
        }
      }
    }
  }`;

const MODIFY_TASK_PRODUCTS = `
  mutation ModifyGroupProducts(
    $groupId: ID!,
    $productIds: [ID]!
  ) {
    modifyTaskProducts(
      groupId: $groupId,
      productIds: $productIds
    )
  }
`;

type ParamTypes = {
  groupId: string;
};

const ManageCloudProducts: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams<ParamTypes>();

  const { loading, error, data } = useQuery(GET_PRODUCTS, { variables: { id: params.groupId } })
  const [modifyTaskProducts] = useMutation(MODIFY_TASK_PRODUCTS)

  const handleSubmit = async (productIds: number[]) => {

    const { data, error } = await modifyTaskProducts(
      {
        variables: {
          groupId: params.groupId,
          productIds: productIds,
        }
      }
    )

    if (error) dispatch(sendErrorNotification(error));
    else {
      dispatch(sendSuccessNotification(`Group products has been modified successfully`));
      history.push('/cloud-products');
    }
  };

  if (loading) {
    return <Loader />;
  } else if (error) {
    dispatch(sendErrorNotification(error));
    return <Unavailable />;
  }

  return (
    <div>
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title">Cloud Products</h1>
              </div>
            </div>
            <div className="col-12">
              <ContentSection>
                <ContentSection.Header>Product Management</ContentSection.Header>
                <ContentSection.Body>
                  <div className="col-lg-12 dt-disp">
                    <ManageProducts
                      region={data.group.region}
                      productIds={data.group.taskProducts.map((tp: any) => tp.product.id)}
                      onSubmit={handleSubmit} />
                  </div>
                </ContentSection.Body>
              </ContentSection>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ManageCloudProducts;
